module.exports = __webpack_public_path__ + "static/sqf-1fba6aafe3a92e31ff5b61081dc4bebf.png";